import React from "react";
import { useHistory } from "react-router-dom";
import tw from "twin.macro";
import styled from "styled-components";
//import { css } from "styled-components/macro"; //eslint-disable-line
import Header, {
  NavLink,
  NavLinks,
  PrimaryLink,
  LogoLink,
  NavToggle,
  DesktopNavLinks
} from "../headers/light.js";
import Logo from "images/custom/logoSkywatch.svg";
import BackgroundImage from "images/custom/hero-background.jpg";
import {
  HASH_API,
  HASH_CONTACT,
  HASH_FEATURES,
  HASH_PRICING,
  HASH_SCENARIOS
} from "helpers/Constants";

const StyledPrimaryLink = styled(PrimaryLink)`
  ${tw`bg-skywatch-buttonBlue hocus:bg-skywatch-buttonBlue focus:shadow-none focus:outline-none`}
`;

const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300 hocus:text-gray-100`}
  }
  ${LogoLink} {
    img {
      ${tw`w-32 mr-3`}
    }
  }
  ${NavLink} {
    ${tw`hover:border-skywatch-buttonBlue hocus:text-skywatch-buttonBlue`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-skywatch-buttonBlue`}
  }
  ${NavToggle}.open {
    ${tw`text-gray-100 hover:text-skywatch-buttonBlue text-black`}
  }
`;
const Container = styled.div`
  ${tw`relative -mx-8 -mt-8 bg-center bg-cover`}
  background-image: url(${BackgroundImage});
`;

const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-xl mx-auto`;
const TwoColumn = tw.div`pt-24 lg:pt-48 pb-32 lg:pb-48 px-4 flex justify-between items-center flex-col lg:flex-row`;
const LeftColumn = tw.div`flex flex-col items-center lg:block`;
const RightColumn = tw.div`w-full sm:w-5/6 lg:w-1/2 mt-16 lg:mt-0 lg:pl-8`;

const Heading = styled.h1`
  ${tw`text-4xl text-center lg:text-left lg:text-5xl font-bold text-gray-100 leading-none`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const SlantedBackground = styled.span`
  ${tw`relative text-5xl text-skywatch-primary500 px-4 -mx-4 py-2 leading-tight`}
  &::before {
    content: "";
    ${tw`absolute inset-0 bg-gray-100 transform -skew-x-12 -z-10`}
  }
`;

const PrimaryAction = tw.button`px-8 py-3 mt-10 text-sm sm:text-base sm:mt-16 sm:px-8 sm:py-4 bg-gray-100 text-skywatch-buttonBlue font-bold rounded shadow transition duration-300 focus:outline-none`;

export default () => {
  let controlNav;
  const navMenu = () => {
    controlNav();
  };

  let history = useHistory();
  const navLinks = [
    <NavLinks key={1}>
      <NavLink href={HASH_FEATURES} onClick={navMenu}>
        獨家 AI 技術
      </NavLink>
      <NavLink href={HASH_SCENARIOS} onClick={navMenu}>
        3 大應用情境
      </NavLink>
      <NavLink href={HASH_API} onClick={navMenu}>
        API 串接
      </NavLink>
      <NavLink href={HASH_PRICING} onClick={navMenu}>
        價格
      </NavLink>
    </NavLinks>,
    <NavLinks key={2}>
      <StyledPrimaryLink href={HASH_CONTACT} onClick={navMenu}>
        聯絡我們
      </StyledPrimaryLink>
    </NavLinks>
  ];

  const logoLink = (
    <LogoLink href="/">
      <img src={Logo} alt="logo" />
    </LogoLink>
  );

  const scrollTo = path => {
    history.push(path);
  };

  return (
    <Container>
      <HeroContainer>
        <StyledHeader
          links={navLinks}
          logoLink={logoLink}
          controlNavCallback={func => (controlNav = func)}
        />
        <TwoColumn>
          <LeftColumn>
            <Heading>
              <span>AI 雲端監控</span>
              <br />
              <SlantedBackground>無人化管理的最佳助手</SlantedBackground>
            </Heading>
            <PrimaryAction
              onClick={() => {
                scrollTo(HASH_CONTACT);
              }}
            >
              聯絡我們
            </PrimaryAction>
          </LeftColumn>
          <RightColumn></RightColumn>
        </TwoColumn>
      </HeroContainer>
    </Container>
  );
};
